import { render, staticRenderFns } from "./IconCelebration.vue?vue&type=template&id=b8316fb2"
import script from "./IconCelebration.vue?vue&type=script&lang=js"
export * from "./IconCelebration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports